import { MobileStepper, useTheme } from '@mui/material'
import colors from 'styles/colors'

const NavStepper = ({
  length,
  activeStep,
  backButton,
  nextButton,
  sx = {}
}) => {
  const theme = useTheme()

  return (
    <MobileStepper
      variant='dots'
      sx={[
        {
          padding: 0,
          background: 'none',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 12,
          '& .MuiMobileStepper-dots': {
            gap: 4
          },
          '& .MuiMobileStepper-dot': {
            backgroundColor: colors.Grey250,
            margin: 0
          },
          '& .MuiMobileStepper-dotActive': {
            backgroundColor: theme.palette.primary.main
          }
        },
        sx
      ]}
      position='static'
      steps={length}
      activeStep={activeStep}
      backButton={backButton}
      nextButton={nextButton}
    />
  )
}
export default NavStepper
